import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { CommonService, LoginReq, SsoService } from 'wire-frame';

const REMEMBER_EMAIL_KEY = 'staffLoginEmail';

@Component({
  selector: 'app-doctor-login',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink, ToastModule],
  providers: [MessageService],
  templateUrl: './doctor-login.component.html',
  styleUrl: './doctor-login.component.scss',
})
export class DoctorLoginComponent implements OnInit {
  /** Isolated split-screen staff login — uses dl-* classes only. */
  showPassword = false;
  rememberMe = true;
  submitting = false;
  avatarMissing = false;

  loginUser: LoginReq = {
    phone: null,
    email: null,
    password: null,
  };

  readonly avatarSrc = 'drsubodh.png';

  constructor(
    private common: CommonService,
    private sso: SsoService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    if (this.common.getJwtToken()) {
      this.common.logout();
    }

    try {
      const savedEmail = localStorage.getItem(REMEMBER_EMAIL_KEY);
      if (savedEmail) {
        this.loginUser.email = savedEmail;
        this.rememberMe = true;
      }
    } catch {
      // ignore storage errors
    }
  }

  get greeting(): string {
    const hour = new Date().getHours();
    if (hour < 12) {
      return 'Good morning';
    }
    if (hour < 17) {
      return 'Good afternoon';
    }
    return 'Good evening';
  }

  login(): void {
    const email = (this.loginUser.email || '').trim();
    const password = (this.loginUser.password || '').trim();

    if (!email || !password) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Missing details',
        detail: 'Please enter your email and password.',
      });
      return;
    }

    this.submitting = true;
    this.loginUser.email = email;
    this.loginUser.password = password;

    this.sso.loginUser(this.loginUser).subscribe({
      next: (res) => {
        this.submitting = false;
        sessionStorage.setItem('user', res?.body?.data?.user_type ?? 'admin');

        const token = this.common.mockToken ?? res?.headers?.get('Authorization');
        if (!token) {
          this.messageService.add({
            severity: 'error',
            summary: 'Sign in failed',
            detail: 'We could not start your session. Please try again.',
          });
          return;
        }

        try {
          if (this.rememberMe) {
            localStorage.setItem(REMEMBER_EMAIL_KEY, email);
          } else {
            localStorage.removeItem(REMEMBER_EMAIL_KEY);
          }
        } catch {
          // ignore storage errors
        }

        const extractedToken = token.startsWith('Bearer ') ? token.substring(7) : token;
        localStorage.setItem('jwtToken', extractedToken);
        this.common.setLoggedInUser(res?.body?.data);
        this.common.redirect('/admin/dashboard');
      },
      error: () => {
        this.submitting = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Sign in failed',
          detail: 'Invalid email or password. Please try again.',
        });
      },
    });
  }
}
